import React from 'react';
import * as Styles from './StepsListStyles';
import iconCircle from '../../../../../assets/icons/step_ok.svg';

interface Props {
  currentStep: number;
}

const StepsList: React.FC<Props> = ({ currentStep }: Props) => {
  return (
    <Styles.ListContainer>
      <Styles.ListItem>
        {currentStep > 1 && <img src={iconCircle} alt="Step 1 OK" />}
        {currentStep < 2 && <Styles.Circle color={currentStep === 1 ? 'black' : 'black24'}>1</Styles.Circle>}

        <Styles.Text color={currentStep === 1 ? 'black' : 'black24'}>
          Informações SNGPC
          {currentStep === 1 && <Styles.Icon name="arrow-right" />}
        </Styles.Text>
      </Styles.ListItem>
      <Styles.ListItem>
        {currentStep > 2 && <img src={iconCircle} alt="Step 1 OK" />}
        {currentStep < 3 && <Styles.Circle color={currentStep === 2 ? 'black' : 'black24'}>2</Styles.Circle>}
        <Styles.Text color={currentStep === 2 ? 'black' : 'black24'}> Empresa e Usuário </Styles.Text>
        {currentStep === 2 && <Styles.Icon name="arrow-right" />}
      </Styles.ListItem>
      <Styles.ListItem>
        {currentStep <= 3 && <Styles.Circle color={currentStep === 3 ? 'black' : 'black24'}>3</Styles.Circle>}

        <Styles.Text color={currentStep === 3 ? 'black' : 'black24'}> Criar conta Memed </Styles.Text>
        {currentStep === 3 && <Styles.Icon name="arrow-right" />}
      </Styles.ListItem>
    </Styles.ListContainer>
  );
};

export default StepsList;
